import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const ESTADOS = {
  activo: { label: 'Activo', bg: '#EAF3DE', color: '#3B6D11' },
  pausado: { label: 'Pausado', bg: '#F5EFD6', color: '#8B6914' },
  cerrado: { label: 'Cerrado', bg: '#f0f0ed', color: '#888' },
};

const ESTADOS_TAREA = {
  pendiente: { label: 'Pendiente', bg: '#f0f0ed', color: '#888' },
  en_curso: { label: 'En curso', bg: '#E6F1FB', color: '#185FA5' },
  hecha: { label: 'Hecha', bg: '#EAF3DE', color: '#3B6D11' },
};

function HistorialCambios({ log }) {
  const [abierto, setAbierto] = useState(false);
  const fmtFecha = (f) => {
    if (!f) return "—";
    try { const d = new Date(f); if (isNaN(d)) return f; return d.toLocaleString("es-ES",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}); }
    catch(e) { return f; }
  };
  return (
    <div style={{background:"white",border:"0.5px solid #e0e0d8",borderRadius:12,padding:20}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}} onClick={() => setAbierto(!abierto)}>
        <div style={{fontSize:13,fontWeight:600,color:"#1a1a1a"}}>Historial de cambios {log.length > 0 && <span style={{fontSize:11,color:"#aaa",fontWeight:400}}>({log.length})</span>}</div>
        <span style={{fontSize:12,color:"#aaa"}}>{abierto ? "▲ Ocultar" : "▼ Mostrar"}</span>
      </div>
      {abierto && <div style={{marginTop:16}}>{log.length === 0 ? <div style={{fontSize:13,color:"#aaa",textAlign:"center",padding:"16px 0"}}>Sin cambios registrados</div> : log.map((entry, i) => (
        <div key={i} style={{display:"flex",alignItems:"baseline",gap:12,padding:"10px 0",borderBottom:"0.5px solid #f0f0ed",fontSize:12}}>
          <span style={{color:"#aaa",flexShrink:0,fontFamily:"monospace",fontSize:11,minWidth:130}}>{fmtFecha(entry.fecha)}</span>
          <span style={{color:"#378ADD",flexShrink:0,fontWeight:500,minWidth:80}}>{entry.usuario}</span>
          <span style={{color:"#666"}}>{entry.texto}</span>
        </div>
      ))}</div>}
    </div>
  );
}

export default function ProyectoDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [proyecto, setProyecto] = useState(null);
  const [tareas, setTareas] = useState([]);
  const [porEmpleado, setPorEmpleado] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [log, setLog] = useState([]);
  const [modalTarea, setModalTarea] = useState(false);
  const [formTarea, setFormTarea] = useState({ nombre: "", descripcion: "", estado: "pendiente", empleado_id: "" });
  const [error, setError] = useState("");
  const [empAbiertos, setEmpAbiertos] = useState({});
  const [etapas, setEtapas] = useState([]);
  const [modalEtapa, setModalEtapa] = useState(false);
  const [formEtapa, setFormEtapa] = useState({ nombre: '' });
  const [todasHoras, setTodasHoras] = useState([]);

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    try {
      const [pRes, tRes, hRes, eRes, lRes, etRes] = await Promise.all([
        API.get("/proyectos"),
        API.get(`/proyectos/${id}/tareas`),
        API.get(`/horas/proyecto/${id}`),
        API.get("/empleados"),
        API.get(`/log?entidad=proyecto&entidad_id=${id}`),
        API.get(`/proyectos/${id}/etapas`),
      ]);
      const p = pRes.data.find(x => x.id === parseInt(id));
      setProyecto(p || null);
      setTareas(tRes.data || []);
      setPorEmpleado(hRes.data?.por_empleado || []);
      setTodasHoras(hRes.data?.todas || []);
      setEmpleados(eRes.data || []);
      setLog(lRes.data || []);
      setEtapas(etRes.data || []);
    } catch(e) {}
    setCargando(false);
  };

  const exportarPDF = () => {
    const meses = {};
    todasHoras.forEach(h => {
      if (!h.fecha) return;
      const d = new Date(h.fecha);
      const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
      const label = d.toLocaleDateString('es-ES', {month:'long', year:'numeric'});
      if (!meses[key]) meses[key] = { label, horas: 0 };
      meses[key].horas += h.horas;
    });
    const mesesOrdenados = Object.entries(meses).sort((a,b) => a[0].localeCompare(b[0]));
    const maxHoras = Math.max(...mesesOrdenados.map(([,v]) => v.horas), 1);
    const barWidth = 40;
    const barGap = 20;
    const chartW = Math.max(400, mesesOrdenados.length * (barWidth + barGap) + 60);
    const chartH = 200;

    let bars = '';
    mesesOrdenados.forEach(([, v], i) => {
      const x = 40 + i * (barWidth + barGap);
      const barH = Math.round((v.horas / maxHoras) * 150);
      const y = chartH - barH - 30;
      bars += `<rect x="${x}" y="${y}" width="${barWidth}" height="${barH}" fill="#378ADD" rx="4"/>`;
      bars += `<text x="${x + barWidth/2}" y="${y - 5}" text-anchor="middle" font-size="11" fill="#378ADD" font-weight="600">${v.horas}h</text>`;
      bars += `<text x="${x + barWidth/2}" y="${chartH - 10}" text-anchor="middle" font-size="9" fill="#888">${v.label.substring(0,3)}</text>`;
    });

    // Calcular participación por empleado
    const participacion = {};
    todasHoras.forEach(h => {
      const nombre = h.empleado_nombre || 'Sin asignar';
      if (!participacion[nombre]) participacion[nombre] = 0;
      participacion[nombre] += h.horas;
    });
    const partEntries = Object.entries(participacion).sort((a,b) => b[1]-a[1]);

    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html><head><title>Reporte: ${proyecto.nombre}</title>
    <style>
      body{font-family:Arial,sans-serif;margin:32px;color:#1a1a1a;font-size:13px}
      h1{font-size:22px;margin-bottom:4px}
      .sub{color:#888;margin-bottom:24px;font-size:13px}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:24px}
      .card{border:1px solid #e0e0d8;border-radius:8px;padding:16px}
      .card h3{font-size:12px;color:#aaa;text-transform:uppercase;letter-spacing:0.05em;margin:0 0 12px 0}
      .row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f0f0ed;font-size:12px}
      .label{color:#888}
      .blue{color:#378ADD;font-weight:600}
      .chart{border:1px solid #e0e0d8;border-radius:8px;padding:16px;margin-bottom:24px}
      .chart h3{font-size:12px;color:#aaa;text-transform:uppercase;margin:0 0 12px 0}
      table{width:100%;border-collapse:collapse;margin-top:16px}
      th{font-size:11px;color:#aaa;text-transform:uppercase;padding:8px;border-bottom:2px solid #eee;text-align:left}
      td{padding:8px;border-bottom:1px solid #f0f0ed;font-size:12px}
      .footer{color:#aaa;font-size:11px;margin-top:32px;border-top:1px solid #eee;padding-top:16px}
    </style></head><body>
    <h1>${proyecto.nombre}</h1>
    <div class="sub">${proyecto.cliente || 'Sin cliente'} · Exportado el ${new Date().toLocaleString('es-ES')}</div>
    <div class="grid">
      <div class="card">
        <h3>Datos del proyecto</h3>
        <div class="row"><span class="label">Estado</span><span>${proyecto.estado}</span></div>
        <div class="row"><span class="label">Fecha inicio</span><span>${proyecto.fecha_inicio ? new Date(proyecto.fecha_inicio).toLocaleDateString('es-ES') : '—'}</span></div>
        <div class="row"><span class="label">Fecha fin</span><span>${proyecto.fecha_fin ? new Date(proyecto.fecha_fin).toLocaleDateString('es-ES') : '—'}</span></div>
        <div class="row"><span class="label">Presupuesto</span><span>${proyecto.presupuesto ? parseFloat(proyecto.presupuesto).toLocaleString('es-ES') + '€' : '—'}</span></div>
        <div class="row"><span class="label">Precio hora venta</span><span>${proyecto.precio_hora_venta ? proyecto.precio_hora_venta + '€/h' : '—'}</span></div>
      </div>
      <div class="card">
        <h3>Resumen económico</h3>
        <div class="row"><span class="label">Horas totales</span><span class="blue">${totalHoras.toFixed(1)}h</span></div>
        ${costeReal > 0 ? `<div class="row"><span class="label">Coste real</span><span>${costeReal.toLocaleString('es-ES', {minimumFractionDigits:2})}€</span></div>` : ''}
        ${ingresoReal ? `<div class="row"><span class="label">Ingreso estimado</span><span>${ingresoReal.toLocaleString('es-ES', {minimumFractionDigits:2})}€</span></div>` : ''}
        ${margen !== null ? `<div class="row"><span class="label">Margen</span><span style="color:${margen>=0?'#3B6D11':'#A32D2D'};font-weight:600">${margen.toLocaleString('es-ES', {minimumFractionDigits:2})}€</span></div>` : ''}
      </div>
    </div>
    ${proyecto.descripcion ? `<div class="card" style="margin-bottom:16px"><h3>Descripción</h3><p style="font-size:13px;color:#444;margin:0">${proyecto.descripcion}</p></div>` : ''}
    ${partEntries.length > 0 ? `
    <div class="card" style="margin-bottom:16px">
      <h3>Equipo del proyecto</h3>
      <table>
        <tr><th>Empleado</th><th>Horas</th><th>% participación</th></tr>
        ${partEntries.map(([nombre, hh]) => `<tr><td>${nombre}</td><td class="blue">${hh}h</td><td>${totalHoras > 0 ? Math.round(hh/totalHoras*100) : 0}%</td></tr>`).join('')}
      </table>
    </div>` : ''}
    ${mesesOrdenados.length > 0 ? `
    <div class="chart">
      <h3>Horas imputadas por mes</h3>
      <svg width="${chartW}" height="${chartH}" xmlns="http://www.w3.org/2000/svg">${bars}</svg>
      <table>
        <tr><th>Mes</th><th>Horas</th><th>% del total</th></tr>
        ${mesesOrdenados.map(([,v]) => `<tr><td>${v.label}</td><td class="blue">${v.horas}h</td><td>${totalHoras > 0 ? Math.round(v.horas/totalHoras*100) : 0}%</td></tr>`).join('')}
        <tr><td><b>Total</b></td><td class="blue"><b>${totalHoras.toFixed(1)}h</b></td><td>100%</td></tr>
      </table>
    </div>` : '<div class="chart"><h3>Horas imputadas por mes</h3><p style="color:#aaa">Sin horas imputadas</p></div>'}
    <div class="footer">Generado por TempoGestión · ${new Date().toLocaleString('es-ES')}</div>
    </body></html>`);
    win.document.close();
  };

  const cambiarEstado = async (nuevoEstado) => {
    await API.put(`/proyectos/${id}`, { ...proyecto, estado: nuevoEstado });
    cargar();
  };

  const guardarTarea = async () => {
    if (!formTarea.nombre?.trim()) { setError("El nombre es obligatorio"); return; }
    try {
      await API.post("/tareas", { nombre: formTarea.nombre, descripcion: formTarea.descripcion || null, estado: formTarea.estado, empleado_id: formTarea.empleado_id ? parseInt(formTarea.empleado_id) : null, proyecto_id: parseInt(id) });
      setModalTarea(false);
      setFormTarea({ nombre: "", descripcion: "", estado: "pendiente", empleado_id: "" });
      cargar();
    } catch(e) { setError("Error al crear tarea"); }
  };

  const cambiarEstadoTarea = async (tareaId, nuevoEstado) => {
    const tarea = tareas.find(t => t.id === tareaId);
    await API.put(`/tareas/${tareaId}`, { ...tarea, estado: nuevoEstado });
    cargar();
  };

  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString("es-ES", {day:"2-digit",month:"2-digit",year:"numeric"}) : "—";

  const totalHoras = porEmpleado.reduce((acc, e) => acc + e.horas_total, 0);
  const costeReal = porEmpleado.reduce((acc, e) => {
    const emp = empleados.find(x => x.nombre === e.nombre);
    return acc + e.horas_total * (parseFloat(emp?.coste_hora) || 0);
  }, 0);
  const ingresoReal = proyecto?.precio_hora_venta ? totalHoras * parseFloat(proyecto.precio_hora_venta) : null;
  const margen = ingresoReal && costeReal ? ingresoReal - costeReal : null;

  if (cargando) return <div style={s.loading}>Cargando...</div>;
  if (!proyecto) return <div style={s.loading}>Proyecto no encontrado</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate("/proyectos")}>← Proyectos</button>
      </div>
      <div style={s.content}>

        <div style={s.header}>
          <div>
            <div style={s.headerNombre}>{proyecto.nombre}</div>
            {proyecto.cliente && <div style={s.headerCliente}>{proyecto.cliente}</div>}
            {proyecto.referencia && <div style={{fontSize:11,color:'#aaa',marginBottom:4,fontFamily:'monospace'}}>{proyecto.referencia}</div>}
            <div style={s.pills}>
              <span style={{...s.pill, background: ESTADOS[proyecto.estado]?.bg, color: ESTADOS[proyecto.estado]?.color}}>{ESTADOS[proyecto.estado]?.label}</span>
            </div>
          </div>
          {usuario?.rol === "admin" && (
            <div style={s.headerActions}>
              {proyecto.estado !== "activo" && <button style={s.btnSuccess} onClick={() => cambiarEstado("activo")}>Activar</button>}
              {proyecto.estado !== "pausado" && <button style={s.btnWarn} onClick={() => cambiarEstado("pausado")}>Pausar</button>}
              {proyecto.estado !== "cerrado" && <button style={s.btnSecondary} onClick={() => cambiarEstado("cerrado")}>Cerrar</button>}
              <button style={s.btnSecondary} onClick={exportarPDF}>↓ Exportar PDF</button>
              <button style={s.btn} onClick={() => navigate(`/proyectos/${id}/editar`)}>Editar</button>
            </div>
          )}
        </div>

        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTitle}>Datos del proyecto</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Fecha inicio</span><span>{fmtFecha(proyecto.fecha_inicio)}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Fecha fin</span><span>{fmtFecha(proyecto.fecha_fin)}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Presupuesto</span><span>{proyecto.presupuesto ? `${parseFloat(proyecto.presupuesto).toLocaleString("es-ES")}€` : "—"}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Precio hora venta</span><span>{proyecto.precio_hora_venta ? `${proyecto.precio_hora_venta}€/h` : "—"}</span></div>
            {proyecto.descripcion && <div style={{...s.infoRow, flexDirection:"column", gap:4}}><span style={s.infoLabel}>Descripción</span><span style={{fontSize:13}}>{proyecto.descripcion}</span></div>}
          </div>
          <div style={s.card}>
            <div style={s.cardTitle}>Resumen económico</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Horas imputadas</span><span style={{fontWeight:600, color:"#378ADD"}}>{totalHoras.toFixed(1)}h</span></div>
            {costeReal > 0 && <div style={s.infoRow}><span style={s.infoLabel}>Coste real</span><span>{costeReal.toLocaleString("es-ES", {minimumFractionDigits:2})}€</span></div>}
            {ingresoReal && <div style={s.infoRow}><span style={s.infoLabel}>Ingreso estimado</span><span>{ingresoReal.toLocaleString("es-ES", {minimumFractionDigits:2})}€</span></div>}
            {margen !== null && <div style={s.infoRow}><span style={s.infoLabel}>Margen</span><span style={{fontWeight:600, color: margen >= 0 ? "#3B6D11" : "#A32D2D"}}>{margen.toLocaleString("es-ES", {minimumFractionDigits:2})}€</span></div>}
          </div>
        </div>

        <div style={s.card}>
          <div style={s.cardHeaderRow}>
            <div style={s.cardTitle}>Tareas</div>
            {usuario?.rol === "admin" && <button style={s.btnSmall} onClick={() => { setFormTarea({ nombre:"", descripcion:"", estado:"pendiente", empleado_id:"" }); setError(""); setModalTarea(true); }}>+ Añadir tarea</button>}
          </div>
          {tareas.length === 0 ? <div style={s.emptySmall}>Sin tareas</div> : tareas.map(t => (
            <div key={t.id} style={s.tareaRow}>
              <div style={s.tareaLeft}>
                <span style={{...s.pill, background: ESTADOS_TAREA[t.estado]?.bg, color: ESTADOS_TAREA[t.estado]?.color, flexShrink:0}}>{ESTADOS_TAREA[t.estado]?.label}</span>
                <div><div style={s.tareaNombre}>{t.nombre}</div>{t.descripcion && <div style={s.tareaDesc}>{t.descripcion}</div>}</div>
              </div>
              <div style={s.tareaRight}>
                {t.empleado_id && <span style={s.tareaEmp}>{empleados.find(e=>e.id===t.empleado_id)?.nombre || "—"}</span>}
                {usuario?.rol === "admin" && <select style={s.selectSmall} value={t.estado} onChange={e => cambiarEstadoTarea(t.id, e.target.value)} onClick={e => e.stopPropagation()}>
                  <option value="pendiente">Pendiente</option>
                  <option value="en_curso">En curso</option>
                  <option value="hecha">Hecha</option>
                </select>}
              </div>
            </div>
          ))}
        </div>

        <div style={s.card}>
          <div style={s.cardHeaderRow}>
            <div style={s.cardTitle}>Etapas del proyecto</div>
            {usuario?.rol === "admin" && <button style={s.btnSmall} onClick={() => { setFormEtapa({nombre:''}); setModalEtapa(true); }}>+ Añadir etapa</button>}
          </div>
          {etapas.length === 0 ? <div style={s.emptySmall}>Sin etapas definidas</div> : (
            etapas.map((e, i) => (
              <div key={e.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 0',borderBottom:'0.5px solid #f0f0ed'}}>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <span style={{fontSize:11,color:'#aaa',fontFamily:'monospace',minWidth:24}}>{String(i+1).padStart(2,'0')}</span>
                  <span style={{fontSize:13,color:'#1a1a1a'}}>{e.nombre}</span>
                </div>
                {usuario?.rol === "admin" && <button style={{background:'none',border:'none',color:'#ccc',cursor:'pointer',fontSize:12}} onClick={async () => { await API.delete(`/etapas/${e.id}`); cargar(); }}>✕</button>}
              </div>
            ))
          )}
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>Horas imputadas</div>
          {porEmpleado.length === 0 ? <div style={s.emptySmall}>Sin horas imputadas</div> : porEmpleado.map((emp, i) => (
            <div key={i} style={{borderBottom:"0.5px solid #f0f0ed"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",cursor:"pointer"}}
                onClick={() => setEmpAbiertos(prev => ({...prev, [i]: !prev[i]}))}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <span style={{fontSize:13,fontWeight:500,color:"#1a1a1a"}}>{emp.nombre}</span>
                  <span style={{fontSize:11,color:"#aaa"}}>{emp.entradas.length} {emp.entradas.length === 1 ? "entrada" : "entradas"}</span>
                </div>
                <div style={{display:"flex",gap:16,alignItems:"center"}}>
                  <span style={{fontSize:11,color:"#aaa"}}>Hoy: <b style={{color:"#1a1a1a"}}>{emp.horas_hoy}h</b></span>
                  <span style={{fontSize:11,color:"#aaa"}}>Semana: <b style={{color:"#1a1a1a"}}>{emp.horas_semana}h</b></span>
                  <span style={{fontSize:11,color:"#aaa"}}>Mes: <b style={{color:"#1a1a1a"}}>{emp.horas_mes}h</b></span>
                  <span style={{fontSize:13,fontWeight:600,color:"#378ADD"}}>{emp.horas_total}h total</span>
                  <span style={{fontSize:12,color:"#aaa"}}>{empAbiertos[i] ? "▲" : "▼"}</span>
                </div>
              </div>
              {empAbiertos[i] && (
                <div style={{paddingBottom:8}}>
                  {emp.entradas.map((h, j) => (
                    <div key={j} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 12px",background:"#fafaf8",borderRadius:8,marginBottom:4,cursor:"pointer"}}
                      onClick={() => navigate(`/horas/${h.id}`)}>
                      <span style={{fontSize:12,color:"#888",minWidth:90}}>{fmtFecha(h.fecha)}</span>
                      <span style={{fontSize:12,color:"#666",flex:1,padding:"0 8px"}}>{h.tarea_nombre || "—"}</span>
                      <span style={{fontSize:12,color:"#aaa",flex:1}}>{h.notas || "—"}</span>
                      <span style={{fontSize:13,fontWeight:600,color:"#378ADD"}}>{h.horas}h →</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <HistorialCambios log={log} />
      </div>

      {modalEtapa && (
        <div style={s.overlay} onClick={() => setModalEtapa(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><div style={s.modalTitle}>Nueva etapa</div><button style={s.closeBtn} onClick={() => setModalEtapa(false)}>✕</button></div>
            <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={formEtapa.nombre} onChange={e => setFormEtapa({nombre: e.target.value})} placeholder="Ej: Fase de diseño, Desarrollo..." autoFocus /></div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalEtapa(false)}>Cancelar</button>
              <button style={s.btn} onClick={async () => {
                if (!formEtapa.nombre.trim()) return;
                await API.post('/etapas', { nombre: formEtapa.nombre, proyecto_id: parseInt(id), orden: etapas.length });
                setModalEtapa(false);
                cargar();
              }}>Crear etapa</button>
            </div>
          </div>
        </div>
      )}

      {modalTarea && (
        <div style={s.overlay} onClick={() => setModalTarea(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}><div style={s.modalTitle}>Nueva tarea</div><button style={s.closeBtn} onClick={() => setModalTarea(false)}>✕</button></div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={formTarea.nombre} onChange={e => setFormTarea({...formTarea, nombre: e.target.value})} /></div>
            <div style={s.field}><label style={s.label}>Descripción</label><input style={s.input} value={formTarea.descripcion} onChange={e => setFormTarea({...formTarea, descripcion: e.target.value})} /></div>
            <div style={s.field}><label style={s.label}>Estado</label>
              <select style={s.input} value={formTarea.estado} onChange={e => setFormTarea({...formTarea, estado: e.target.value})}>
                <option value="pendiente">Pendiente</option><option value="en_curso">En curso</option><option value="hecha">Hecha</option>
              </select>
            </div>
            <div style={s.field}><label style={s.label}>Asignar a</label>
              <select style={s.input} value={formTarea.empleado_id} onChange={e => setFormTarea({...formTarea, empleado_id: e.target.value})}>
                <option value="">Sin asignar</option>
                {empleados.filter(e=>e.activo).map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
              </select>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalTarea(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardarTarea}>Crear tarea</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:"flex", flexDirection:"column", minHeight:"100vh", background:"#f5f5f3", fontFamily:"-apple-system, BlinkMacSystemFont, Inter, sans-serif" },
  loading: { display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", color:"#aaa", fontSize:14 },
  topbar: { background:"white", borderBottom:"0.5px solid #e0e0d8", padding:"0 24px", height:48, display:"flex", alignItems:"center" },
  backBtn: { background:"none", border:"none", fontSize:13, color:"#378ADD", cursor:"pointer", fontWeight:500 },
  content: { padding:24, display:"flex", flexDirection:"column", gap:16 },
  header: { background:"white", border:"0.5px solid #e0e0d8", borderRadius:12, padding:24, display:"flex", alignItems:"flex-start", justifyContent:"space-between", flexWrap:"wrap", gap:16 },
  headerNombre: { fontSize:20, fontWeight:600, color:"#1a1a1a", marginBottom:4 },
  headerCliente: { fontSize:13, color:"#888", marginBottom:8 },
  pills: { display:"flex", gap:6 },
  pill: { fontSize:11, padding:"2px 8px", borderRadius:10, fontWeight:500, display:"inline-block" },
  headerActions: { display:"flex", gap:8, flexWrap:"wrap" },
  grid2: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 },
  card: { background:"white", border:"0.5px solid #e0e0d8", borderRadius:12, padding:20 },
  cardTitle: { fontSize:13, fontWeight:600, color:"#1a1a1a", marginBottom:16 },
  cardHeaderRow: { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 },
  infoRow: { display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"0.5px solid #f0f0ed", fontSize:13, color:"#1a1a1a" },
  infoLabel: { color:"#888" },
  tareaRow: { display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 0", borderBottom:"0.5px solid #f0f0ed" },
  tareaLeft: { display:"flex", alignItems:"center", gap:12 },
  tareaRight: { display:"flex", alignItems:"center", gap:8 },
  tareaNombre: { fontSize:13, fontWeight:500, color:"#1a1a1a" },
  tareaDesc: { fontSize:12, color:"#aaa", marginTop:2 },
  tareaEmp: { fontSize:12, color:"#888" },
  selectSmall: { padding:"4px 8px", borderRadius:6, border:"0.5px solid #d0d0c8", fontSize:12, background:"white", outline:"none" },
  emptySmall: { fontSize:13, color:"#aaa", padding:"16px 0", textAlign:"center" },
  btn: { background:"#378ADD", color:"white", border:"none", borderRadius:8, padding:"8px 14px", fontSize:13, fontWeight:500, cursor:"pointer" },
  btnSmall: { background:"#378ADD", color:"white", border:"none", borderRadius:6, padding:"5px 10px", fontSize:12, cursor:"pointer" },
  btnSecondary: { background:"white", color:"#666", border:"0.5px solid #d0d0c8", borderRadius:8, padding:"8px 14px", fontSize:13, cursor:"pointer" },
  btnSuccess: { background:"#EAF3DE", color:"#3B6D11", border:"none", borderRadius:8, padding:"8px 14px", fontSize:13, cursor:"pointer" },
  btnWarn: { background:"#F5EFD6", color:"#8B6914", border:"none", borderRadius:8, padding:"8px 14px", fontSize:13, cursor:"pointer" },
  overlay: { position:"fixed", inset:0, background:"rgba(0,0,0,0.3)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 },
  modal: { background:"white", borderRadius:12, border:"0.5px solid #e0e0d8", padding:24, width:"100%", maxWidth:480, maxHeight:"90vh", overflowY:"auto" },
  modalHeader: { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:"#1a1a1a" },
  closeBtn: { background:"none", border:"none", fontSize:16, cursor:"pointer", color:"#aaa" },
  errorBox: { background:"#FCEBEB", color:"#A32D2D", borderRadius:8, padding:"10px 14px", fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  label: { display:"block", fontSize:13, color:"#444", marginBottom:6, fontWeight:500 },
  input: { width:"100%", padding:"9px 12px", borderRadius:8, border:"0.5px solid #d0d0c8", fontSize:14, outline:"none", boxSizing:"border-box", background:"white" },
  modalFooter: { display:"flex", justifyContent:"flex-end", gap:10, marginTop:24 },
};
